export default {
  errors: {
    UNKNOWN_ERROR: "Ha ocurrido un error inesperado. Por favor, inténtalo más tarde.",
    AUTH_BAD_AUTHENTICATION: "Autenticación inválida. Por favor, inténtalo de nuevo.",
    AUTH_ROLE_NOT_FOUND: "Tu usuario no tiene permisos de administrador.",
    AUTH_USER_ALREADY_REGISTERED: "Este email ya está registrado.",
    AUTH_USER_NOT_FOUND: "Usuario no encontrado. Por favor, revisa tu email.",
    AUTH_BAD_INPUT_PARAMETER: "Datos de entrada inválidos. Por favor, revisa tu información.",
    AUTH_BAD_TYPE_RENDERED: "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo.",
    AUTH_COMMON_ERROR: "Ha ocurrido un error. Por favor, inténtalo de nuevo.",
    AUTH_BAD_AUTH_CODE_TYPE: "Tipo de código de autenticación inválido.",
    AUTH_RATE_LIMIT_EXCEEDED: "Demasiadas solicitudes. Por favor, espera un momento e inténtalo de nuevo.",
    unknown: "Ha ocurrido un error inesperado. Por favor, inténtalo más tarde.",
  },
  shared: {
    step: {
      credentials: "Introduce tu correo",
      verification: "Valida tu correo",
    },
    email: {
      label: "Email",
      placeholder: "tu@email.com",
    },
    button: "Continuar",
    error: {
      sendingCode: "Error al enviar el código",
    },
    verify: {
      title: "Hemos enviado un código a <strong>{{email}}</strong>",
      subtitle: "Introduce el código de 6 dígitos",
      codeLabel: "Código de verificación",
      changeEmail: "¿No es tu correo? Volver",
      resendCode: "Reenviar código",
      resendSuccess: "Código reenviado. Revisa tu bandeja de entrada.",
      error: {
        incompleteCode: "Por favor, completa el código de 6 dígitos",
        invalidCode: "Código inválido o expirado",
        title: "Error",
        message: "El código que has introducido no es el correcto, vuelve a intentarlo por favor.",
      },
    },
  },
  login: {
    title: "Panel de Administración",
    subtitle: "Accede al panel de gestión",
    brandSubtitle: "Gestión y gobernanza descentralizada",
    verify: {
      button: "Iniciar sesión",
    },
  },
}
